import * as dayjs from "dayjs";
import { CULTURES_WITH_SUNDAY_AS_START_OF_WEEK } from "Services/constants";

export const calendarUtils = () => {
	const addPlaceholderDaysInFront = (index: number, culture: string) =>
		Array.from(Array(doesWeekStartOnSunday(culture) ? (index + 7) % 7 : index));

	const addPlaceholderDaysAfter = (index: number, culture: string) =>
		Array.from(Array(6 - (doesWeekStartOnSunday(culture) ? (index + 7) % 7 : index)));

    // Export
    const doesWeekStartOnSunday = (culture: string) =>
		CULTURES_WITH_SUNDAY_AS_START_OF_WEEK.includes(culture.toLowerCase());

	const getMonthCalendar = (monthDate: dayjs.Dayjs, culture: string): dayjs.Dayjs[][] => {
		const firstDayIndex = dayjs(monthDate).startOf("month").weekday();
		let days: dayjs.Dayjs[] = addPlaceholderDaysInFront(firstDayIndex, culture);

		let day = dayjs(monthDate).startOf("month");
		const endOfMonth = dayjs(monthDate).endOf("month");

		while (day.isSameOrBefore(endOfMonth)) {
			days.push(dayjs(day));
			day = dayjs(day.add(1, "day"));
		}

		const lastDayIndex = dayjs(monthDate).endOf("month").weekday();
		days = days.concat(addPlaceholderDaysAfter(lastDayIndex, culture));

		const weeks = days.reduce((weeksAcc, weekDay, i) => {
			const weekIndex = Math.floor(i / 7);
			weeksAcc[weekIndex] = [].concat(weeksAcc[weekIndex] || [], weekDay);
			return weeksAcc;
		}, [] as dayjs.Dayjs[][]);

		return weeks;
	};

	return {
		doesWeekStartOnSunday,
		getMonthCalendar,
	};
};
